import { FC } from 'react';
import { ErrorBoundary as SentryBoundary } from '@sentry/react';
import { DefaultErrorPage } from '../ErrorPages';

const ErrorBoundary: FC = ({ children }) => (
  <SentryBoundary fallback={<DefaultErrorPage />}>{children}</SentryBoundary>
);

export default ErrorBoundary;
